import { jsx as a } from "react/jsx-runtime";
import { useRef as d, useEffect as f, useMemo as p } from "react";
import { ThemeColor as i } from "../../../types.js";
import { isDark as u, updateBodyClass as T, updateMetaThemeColor as C } from "../../../utils/theme.js";
import { Theme as r, ThemeContext as v } from "../ThemeContext.js";
import y from "./ThemeProvider.module.css.js";
const j = (n) => {
  const { children: h, systemTheme: o = r.light, onThemeChange: m, theme: e = r.auto } = n, t = e === r.auto ? o : e, s = u(t) ? i.dark : i.light, l = d(null);
  f(() => {
    T(t), C(e, s, l);
  }, [t, s, e]);
  const c = p(
    () => ({
      theme: e,
      systemTheme: o,
      onThemeChange: m
    }),
    [e, o, m]
  );
  return /* @__PURE__ */ a(v.Provider, { value: c, children: /* @__PURE__ */ a("div", { className: y.themeContainer, "data-test": "theme-container", children: h }) });
};
export {
  j as ThemeProvider
};
